import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import EsApplyPckgNavInputBox from './EsApplyPckgNavInputBox';
import EsApplyPckgProdBox from './EsApplyPckgProdBox';


const EsApplyPckgComp = styled.div`
    display: ${props => props.display};
    position: fixed;
    width: 100%;
    bottom: ${props => props.bottom};
    left: 0;
    z-index: 200;
    -webkit-transition: bottom .5s ease-in;
    -o-transition: bottom .5s ease-in;
    transition: bottom .5s ease-in
`;

const EsApplyPckgBtnBlock = styled.button`
    position: absolute;
    top: -15px;
    left: 50%;
    width: 114px;
    height: 30px;
    background-color: #79b88a;
    border-radius: 15px;
    font-size: 14px;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    z-index: 3;

    &::before {
        content: '';
        display: inline-block;
        width: 15px;
        height: 8px;
        margin-right: 10px;
        vertical-align: 1px;
        background-image: url(${props => props.img});
    }
`;

const EsApplyPckgAnLayerBlock = styled.div`
    display: ${props => props.active ? 'block' : 'none'};
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0,0,0,.4);
    z-index: 1
`;

const EsApplyPckgNavBoxBlock = styled.div`
    position: relative;
    width: 100%;
    margin: 0 auto;
    padding: 30px 0;
    background-color: #ececec;
    border-top: 1px solid #79b88a;
    color: #333;
    font-size: 15px;
    z-index: 2;
`;

const EsApplyPckgNavBoxSzWrapBlock = styled.div`
    width: 100%;
    max-width: 1176px;
    margin: 0 auto;
`;


const EsApplyPckg = () => {
    const [showComp, setShowComp] = useState(false);
    const [active, setActive] = useState(false);

    const { esApplyShowLayer, esApplyProdList } = useSelector(
        ({ esApplyReducer }) => ({
            esApplyShowLayer: esApplyReducer.esApplyShowLayer,
            esApplyProdList: esApplyReducer.esApplyProdList
        })
    )

    const upArrow = "/assets/images/icon/da-icon-active.png";
    const downArrow = "/assets/images/icon/da-icon.png"

    // Active 활성 / 비활성 버튼 
    const handleArrowClick = () => {
        setActive(!active);
    }

    useEffect(() => {
        // console.log("+++++++ esApplyProdList : " + esApplyShowLayer);
        setShowComp(esApplyShowLayer);
    }, [esApplyShowLayer, esApplyProdList])

    return (
        <EsApplyPckgComp display={showComp ? 'block' : 'none'}
            bottom={active ? '0px' : '-334px'}>
            <EsApplyPckgBtnBlock
                img={active ? downArrow : upArrow}
                onClick={handleArrowClick}>
                전체보기
            </EsApplyPckgBtnBlock>
            <EsApplyPckgAnLayerBlock active={active} />
            <EsApplyPckgNavBoxBlock>
                <EsApplyPckgNavBoxSzWrapBlock>
                    <EsApplyPckgNavInputBox />
                    <EsApplyPckgProdBox esApplyProdList={esApplyProdList} />
                </EsApplyPckgNavBoxSzWrapBlock>
            </EsApplyPckgNavBoxBlock>
        </EsApplyPckgComp>
    );
};

export default EsApplyPckg;